const tPath = "mainPage.archives.callsHistory";

export default tPath;
